import { EndpointBuilder } from '@reduxjs/toolkit/query';
import {
  FetchArgs,
  FetchBaseQueryError,
  FetchBaseQueryMeta
} from '@reduxjs/toolkit/query';
import { BaseQueryFn } from '@reduxjs/toolkit/query';
import {
  QueryParamsDLMS,
  ResponseBaseWithPagination,
  UsersListResponse
} from '../types';
import { CreateUserPayload } from '../types/records/user';

export const userAccessPanelAPIDLMSEndpoints = (
  builder: EndpointBuilder<
    BaseQueryFn<
      string | FetchArgs,
      unknown,
      FetchBaseQueryError,
      NonNullable<unknown>,
      FetchBaseQueryMeta
    >,
    string,
    'userAccessPanelAPIDLMS'
  >
) => ({
  getUsersList: builder.query<UsersListResponse, QueryParamsDLMS>({
    query: (params) => ({
      url: `api/v1/user/get-users`,
      params
    }),
    providesTags: ['dlmsUserList']
  }),
  createUserDLMS: builder.mutation<
    ResponseBaseWithPagination<void>,
    CreateUserPayload
  >({
    query: (payload) => ({
      url: 'api/v1/user/register',
      method: 'POST',
      body: payload
    }),
    invalidatesTags: ['dlmsUserList']
  })
});
